import GdprAccordion from './gdprAccordion';

class GdprTableLoad {
    constructor() {
        this.accordion = new GdprAccordion();
        this.page = 1;
        // this.itemsPerPage = 10;
        this.allResultsLoaded = false;
        this.loadingMore = false;
        this.resetOrder = document.querySelector('.blog-archive__gdpr-table-reset-order');
        this.baseUrl = window.location.origin;
        this.ajaxUrl = `${this.baseUrl}/wp-admin/admin-ajax.php`;
        this.gdprTableBody = document.getElementById('gdprTableBody');
        this.gdprTable = document.querySelector('.blog-archive__gdpr-table');
        this.loadMoreLoader = document.getElementById('loadMoreLoader');
        this.inputCompany = document.getElementById('inputCompany');
        this.gdprElement = document.querySelector('.blog-archive__gdpr');
        this.displayedElements = 10;
        this.sortingElements = document.querySelectorAll('.blog-archive__gdpr-table-heading');
        this.sortingOption = '';
        this.sortingDirection = '';
        if (this.gdprTable && this.gdprTableBody) {
            this.setupEventListeners(); // Dodajemy nasłuchiwanie zdarzeń
            this.fetchTotalCount('');
            this.stopFormSubmit(); // Pobieramy początkowe dane
            console.log(`Total count script start = ${this.totalCount}`);
            console.log(`Displayed items script start = ${this.displayedElements}`);
        }
    }

    stopFormSubmit() {
        this.inputCompany.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
                event.preventDefault(); // Zablokowanie wysyłania formularza
                this.fetchFilteredData();
            }
        });
        this.inputCompany.addEventListener('input', () => {
            console.log('Input company change');
            this.fetchFilteredData();
        });
    }

    setupEventListeners() {
        $('#selectYear, #selectCountry, #selectRodoArticle').on('change', () => {
            this.fetchFilteredData();
        });

        window.addEventListener('scroll', this.handleScroll.bind(this));

        this.sortingElements.forEach(element => {
            if (!element.classList.contains('info')) {
                element.addEventListener('click', () => {
                    this.resetOrder.classList.remove('hidden');

                    this.sortingElements.forEach(el => {
                        if (el !== element) {
                            el.classList.remove('sort-desc', 'sort-asc');
                            el.classList.add('sort-asc');
                        }
                    });

                    if (element.classList.contains('sort-desc')) {
                        element.classList.remove('sort-desc');
                        element.classList.add('sort-asc');
                        this.sortingDirection = 'ASC';
                    } else if (element.classList.contains('sort-asc')) {
                        element.classList.add('sort-desc');
                        element.classList.remove('sort-asc');
                        this.sortingDirection = 'DESC';
                    }
                    // Set the sorting option based on the element's class
                    if (element.classList.contains('date')) {
                        this.sortingOption = 'data';
                    } else if (element.classList.contains('country')) {
                        this.sortingOption = 'kraj';
                    } else if (element.classList.contains('penalty')) {
                        this.sortingOption = 'kara';
                    } else if (element.classList.contains('entity')) {
                        this.sortingOption = 'ukarany_podmiot';
                    } else if (element.classList.contains('info')) {
                        this.sortingOption = 'info';
                    }
                    console.log(`Sorting option: ${this.sortingOption}` + ` sorting direction = ${this.sortingDirection}`);
                    // Fetch data with the new sorting option
                    this.fetchFilteredData();
                });
            }
        });

        this.resetOrder.addEventListener('click', () => {
            this.sortingDirection = '';
            this.sortingOption = '';
            this.resetOrder.classList.add('hidden');
            this.sortingElements.forEach(element => {
                element.classList.remove('sort-desc', 'sort-asc');
                element.classList.add('sort-asc');
            });
            this.fetchFilteredData();
        });
    }

    fetchTotalCount(queryParams) {
        const xhr = new XMLHttpRequest();
        xhr.onreadystatechange = () => {
            if (xhr.readyState === XMLHttpRequest.DONE) {
                if (xhr.status === 200) {
                    const totalCount = JSON.parse(xhr.responseText).count;
                    this.totalCount = totalCount;
                    console.log(`Total count request from fetch: ${this.totalCount}`); // Wyświetlenie całkowitej liczby elementów w konsoli

                    if (this.totalCount <= this.displayedElements) {
                        this.allResultsLoaded = true;
                        console.log(`Zaladowano wszystkie wyniki z fetch total count i zmieniono wartość allResultsLoaded na ${this.allResultsLoaded}`);
                    } else {
                        console.log(`Istnieje więcej wyników do wyświetlenia`);
                        this.allResultsLoaded = false;
                    }
                } else {
                    console.error('Wystąpił błąd podczas pobierania całkowitej liczby elementów.');
                }
            }
        };

        xhr.open('GET', `${this.ajaxUrl}?action=count_gdpr_table${queryParams}`, true); // Endpoint dla zapytania COUNT
        xhr.send();
    }

    fetchFilteredData() {
        this.displayedElements = 0;
        const year = $('#selectYear').val();
        const country = $('#selectCountry').val();
        const rodoArticle = $('#selectRodoArticle').val();
        const company = $('#inputCompany').val();
        let orderBy = this.sortingOption;
        let order = this.sortingDirection;

        this.page = 1; // Reset to first page on filter change

        const params = new URLSearchParams({
            action: 'filters_gdpr_table',
            page: this.page,
            year: year,
            country: country,
            rodo_article: rodoArticle,
            company: company,
            orderby: orderBy,
            order: order,
        });

        let generatedAjaxGet = '';
        if (year && year !== '') {
            if (year === 'Brak danych') {
                console.log('wartosc year: ', year);
            }
            generatedAjaxGet += `&year=${year}`;
        }
        if (country && country !== '') {
            generatedAjaxGet += `&country=${country}`;
        }
        if (rodoArticle && rodoArticle !== '') {
            generatedAjaxGet += `&rodo_article=${encodeURIComponent(rodoArticle)}`;
        }
        if (company && company !== '') {
            generatedAjaxGet += `&company=${company}`;
        }

        if (orderBy && orderBy !== '') {
            generatedAjaxGet += `&order_by=${orderBy}`;
        }

        if (order && order !== '') {
            generatedAjaxGet += `&order_type=${this.sortingDirection}`;
        }

        console.log(generatedAjaxGet);

        this.fetchTotalCount(generatedAjaxGet);

        const xhr = new XMLHttpRequest();
        xhr.onreadystatechange = () => {
            if (xhr.readyState === XMLHttpRequest.DONE) {
                if (xhr.status === 200) {
                    const data = JSON.parse(xhr.responseText);
                    this.gdprTableBody.innerHTML = ''; // Clear table before adding new data
                    this.appendData(data);
                } else {
                    console.error('Error fetching filtered data.');
                }
            }
        };

        xhr.open('GET', `${this.ajaxUrl}?action=filters_gdpr_table&page=${this.page}${generatedAjaxGet}`, true);
        xhr.send();
    }

    handleScroll() {
        const { clientHeight } = document.documentElement;
        const { bottom } = this.gdprElement.getBoundingClientRect();

        if (bottom <= clientHeight - 200 && !this.allResultsLoaded && !this.loadingMore) {
            console.log(`bottom = ${bottom}, clientHeight = ${clientHeight} `);
            console.log(`clientHeight - 200 = ${clientHeight - 200}`);

            if (!this.allResultsLoaded) {
                this.loadingMore = true;
                this.handleLoadMore();
                console.log(`DEBUG(should be false) this.allResultsLoaded = ${this.allResultsLoaded}`);
            }
            else {
                console.log(`DEBUG(should be true) this.allResultsLoaded = ${this.allResultsLoaded}`);
            }
        }
    }

    handleLoadMore() {
        this.page++;
        if (!this.allResultsLoaded) {
            this.loadMoreLoader.classList.remove('hidden');
            const year = $('#selectYear').val();
            const country = $('#selectCountry').val();
            const rodoArticle = $('#selectRodoArticle').val();
            const company = $('#inputCompany').val();
            let orderBy = this.sortingOption;
            let order = this.sortingDirection;

            let generatedAjaxGet = '';
            if (year && year !== '') {
                generatedAjaxGet += `&year=${year}`;
            }
            if (country && country !== '') {
                generatedAjaxGet += `&country=${country}`;
            }
            if (rodoArticle && rodoArticle !== '') {
                generatedAjaxGet += `&rodo_article=${encodeURIComponent(rodoArticle)}`;
            }
            if (company && company !== '') {
                generatedAjaxGet += `&company=${company}`;
            }
            if (orderBy && orderBy !== '') {
                generatedAjaxGet += `&order_by=${orderBy}`;
            }
            if (order && order !== '') {
                generatedAjaxGet += `&order_type=${this.sortingDirection}`;
            }

            const xhr = new XMLHttpRequest();
            xhr.onreadystatechange = () => {
                if (xhr.readyState === XMLHttpRequest.DONE) {
                    if (xhr.status === 200) {
                        const data = JSON.parse(xhr.responseText);
                        if (data.length > 0) {
                            this.appendData(data);
                        }
                    } else {
                        console.error('Error fetching data.');
                    }
                    this.loadMoreLoader.classList.add('hidden');
                }
            };

            xhr.open('GET', `${this.ajaxUrl}?action=load_more_gdpr&page=${this.page}${generatedAjaxGet}`, true);
            xhr.send();
            this.fetchTotalCount(`&page=${this.page}${generatedAjaxGet}`);

            setTimeout(() => {
                this.loadingMore = false;
            }, 200)

        }
    }


    addSpaces(number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    appendData(data) {
        if (!Array.isArray(data)) {
            console.error('Otrzymane dane nie są tablicą.');
            console.log(data);
            return;
        }

        if (data.length === 0) {
            console.warn('Otrzymane dane są puste.');
            return;
        }
        data.forEach(item => {
            let formattedPrice = this.addSpaces(item.kara);
            // console.log(formattedPrice);
            const tableRow = document.createElement('tr');
            tableRow.classList.add('blog-archive__gdpr-table-element', 'container-gdpr-table', 'text-m', 'bold', 'jsGdprAccordionElement');
            if (window.innerWidth < 1024) {
                tableRow.innerHTML = `
                <td class="blog-archive__gdpr-table-element-date">${item.data}</td>
                <td class="blog-archive__gdpr-table-element-country text-m bold">${item.kraj}</td>
                <td class="blog-archive__gdpr-table-element-penalty text-m bold">${formattedPrice} EUR</td>
                <td class="blog-archive__gdpr-table-element-entity text-m bold">${item.ukarany_podmiot}</td>
                <td class="blog-archive__gdpr-table-element-info text-m bold">
                    <div class="icon__table-arrow-down">
                        <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.5938 2.02734L6.99805 7.38867C6.82227 7.53516 6.64648 7.59375 6.5 7.59375C6.32422 7.59375 6.14844 7.53516 6.00195 7.41797L0.376953 2.02734C0.0839844 1.76367 0.0839844 1.29492 0.347656 1.03125C0.611328 0.738281 1.08008 0.738281 1.34375 1.00195L6.5 5.92383L11.627 1.00195C11.8906 0.738281 12.3594 0.738281 12.623 1.03125C12.8867 1.29492 12.8867 1.76367 12.5938 2.02734Z" fill="#27A1A9"/>
                        </svg>
                    </div>
                </td>
            `;

                const detailsRow = document.createElement('tr');
                detailsRow.innerHTML = `
                <td colspan="5">
                    <div class="blog-archive__gdpr-table-element-content container-gdpr-table jsGdprAccordionContent">
                    	<div class="blog-archive__gdpr-table-element-entity--mobile">
							<div class="blog-archive__gdpr-table-element--title text-m bold">Ukarany podmiot:</div>
							<div class="blog-archive__gdpr-table-element--content text-m medium">${item.ukarany_podmiot}</div>
						</div>
                        <div class="blog-archive__gdpr-table-element-summary">
                            <div class="blog-archive__gdpr-table-element--title text-m bold">Podsumowanie:</div>
                            <div class="blog-archive__gdpr-table-element--content text-m medium">${item.kara_tresc}</div>
                        </div>
                        ${item.paragraf && item.paragraf !== '' ? `
                            <div class="blog-archive__gdpr-table-element-legal">
                                <div class="blog-archive__gdpr-table-element--title text-m bold">Podstawy prawne:</div>
                                <div class="blog-archive__gdpr-table-element--content text-m medium">${item.paragraf}</div>
                            </div>
                            `: ''}
                        ${item.decyzja_link && item.decyzja_link !== '' ? `
                        <div class="blog-archive__gdpr-table-element-decision">
                            <div class="blog-archive__gdpr-table-element--title text-m bold">Decyzja:</div>
                            <a class="blog-archive__gdpr-table-element--content text-m medium" href="${item.decyzja_link}" target="_blank" aria-label="Link do decyzji">link</a>
                        </div>
                        ` : ''}
                    </div>
                </td> `;

                this.gdprTableBody.appendChild(tableRow);
                this.gdprTableBody.appendChild(detailsRow);
            } else {
                tableRow.innerHTML = `
                <td class="blog-archive__gdpr-table-element-date">${item.data}</td>
                <td class="blog-archive__gdpr-table-element-country text-m bold">${item.kraj}</td>
                <td class="blog-archive__gdpr-table-element-penalty text-m bold">${formattedPrice} EUR</td>
                <td class="blog-archive__gdpr-table-element-entity text-m bold">${item.ukarany_podmiot}</td>
                <td class="blog-archive__gdpr-table-element-info text-m bold">
                    <div class="icon__table-arrow-down">
                        <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.5938 2.02734L6.99805 7.38867C6.82227 7.53516 6.64648 7.59375 6.5 7.59375C6.32422 7.59375 6.14844 7.53516 6.00195 7.41797L0.376953 2.02734C0.0839844 1.76367 0.0839844 1.29492 0.347656 1.03125C0.611328 0.738281 1.08008 0.738281 1.34375 1.00195L6.5 5.92383L11.627 1.00195C11.8906 0.738281 12.3594 0.738281 12.623 1.03125C12.8867 1.29492 12.8867 1.76367 12.5938 2.02734Z" fill="#27A1A9"/>
                        </svg>
                    </div>
                </td> `;

                const detailsRow = document.createElement('tr');
                detailsRow.innerHTML = `
                <td colspan="5">
                    <div class="blog-archive__gdpr-table-element-content container-gdpr-table jsGdprAccordionContent">
                        <div class="blog-archive__gdpr-table-element-summary">
                            <div class="blog-archive__gdpr-table-element--title text-m bold">Podsumowanie:</div>
                            <div class="blog-archive__gdpr-table-element--content text-m medium">${item.kara_tresc}</div>
                        </div>
                        ${item.paragraf && item.paragraf !== '' ? `
                            <div class="blog-archive__gdpr-table-element-legal">
                                <div class="blog-archive__gdpr-table-element--title text-m bold">Podstawy prawne:</div>
                                <div class="blog-archive__gdpr-table-element--content text-m medium">${item.paragraf}</div>
                            </div>
                            `: ''}
                        ${item.decyzja_link && item.decyzja_link !== '' ? `
                        <div class="blog-archive__gdpr-table-element-decision">
                            <div class="blog-archive__gdpr-table-element--title text-m bold">Decyzja:</div>
                            <a class="blog-archive__gdpr-table-element--content text-m medium" href="${item.decyzja_link}" target="_blank" aria-label="Link do decyzji">link</a>
                        </div>
                        ` : ''}
                    </div>
                </td>`;

                this.gdprTableBody.appendChild(tableRow);
                this.gdprTableBody.appendChild(detailsRow);
            }
        });

        this.accordion.refreshAccordion();
        console.log(data);
        console.log(`Data length: ${data.length} `);
        this.displayedElements += data.length;
        console.log(`Displayed elements: ${this.displayedElements}`);
        if (this.totalCount <= this.displayedElements) {
            this.allResultsLoaded = true;
            console.log(`Zaladowano wszystkie wyniki i zmieniono wartość allResultsLoaded na ${this.allResultsLoaded}`);
        }
    }
}

export default GdprTableLoad;
